import React from 'react'
import styled from 'styled-components'
import Scroll from 'react-scroll'

import Link from './link'

export default styled(({ className, root, to, children }) =>
  root
    ? <Scroll.Link to={to} smooth={true}>{children}</Scroll.Link>
    : <Link to={to}>{children}</Link>
)`

`
